import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  escapeHTMLButtonLabel: {
    id: 'authoring.texteditor.codeEditor.escapeHTMLButton',
    defaultMessage: 'Unescape HTML Literals',
    description: 'Label For escape special html charectars button',
  },
});

export default messages;
